import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getStorageItem,
  removeStorageItem,
  setStorageItem,
} from "../../utils/localStorage";
import { EntitiesResponse } from "../../pages/SelectEntityPage/SelectEntityPage";
import { IUser2 } from "../../models/user copy";
import { IDirector } from "../../models/director";

export interface MeState {
  me: { me: any; type: "director" | "athlete" } | undefined;
  selectedDirector: any | undefined;
  selecyedAthelete: any | undefined;
  selectedEntity:
    | ((EntitiesResponse["directors"][0] | (IUser2<IDirector> & IDirector)) & {
        image?: { image?: undefined };
      })
    | undefined;
  entities: EntitiesResponse | undefined;
}

const initialState = {
  me: getStorageItem("me"),
  selectedDirector: getStorageItem("selectedDirector"),
  selecyedAthelete: undefined,
  selectedEntity: undefined,
  entities: undefined,
} as MeState;

const meSlice = createSlice({
  name: "me",
  initialState,
  reducers: {
    setMe(state: MeState, action: PayloadAction<MeState["me"]>) {
      if (action.payload) {
        state.me = action.payload;
      } else {
        state.me = undefined;
      }
    },
    setSelectedDirector(
      state: MeState,
      action: PayloadAction<MeState["selectedDirector"]>
    ) {
      state.selectedDirector = action.payload;
    },
    setSelectedEntity(
      state: MeState,
      action: PayloadAction<MeState["selectedEntity"]>
    ) {
      if (action.payload) {
        setStorageItem("selectedEntity", action.payload);
      } else {
        removeStorageItem("selectedEntity");
      }
      state.selectedEntity = action.payload;
    },
    setEntities(state: MeState, action: PayloadAction<MeState["entities"]>) {
      state.entities = action.payload;
    },
  },
});

export const { setMe, setSelectedDirector, setSelectedEntity, setEntities } =
  meSlice.actions;
export default meSlice.reducer;
